/*
 * Copyright (c) 2025 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import i18n from "i18next";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";


import { BasicApp } from "@ef/components-app";
import AppContext, { AppConfig } from "@ef/components-app/AppContext";

import { ThemeWrapper } from "@ef/theme-apeiros";

import themeOptions from "./theme";

import SaApp from "./SaApp";

export default function App(config: AppConfig) {
    React.useEffect(() => {
        SaApp.useHistory(config.history);
        SaApp.init();
    }, [config.history]);

    // Provide home function directly in context
    const configWithHome = {
        ...config,
        home: () => config.history?.push("/app/#/")
    };

    return (
        <AppContext.Provider value={configWithHome}>
            <Provider store={SaApp.getStore()}>
                <ThemeWrapper theme={themeOptions}>
                    <I18nextProvider i18n={i18n}>
                        <BasicApp />
                    </I18nextProvider>
                </ThemeWrapper>
            </Provider>
        </AppContext.Provider>
    );
}
